import requestAdmin from '@/plugins/admin_axios'
import requestAnonimo from '@/plugins/axios_anonymous'

export const consultarBiometriaAdminApi = async (cpf) => {
  const response = await requestAdmin.get('/gateways/biometria/consultar/', { params: { cpf } })
  return response.data
}

export const consultarBiometriaPublicoApi = async (cpf, detalhado = false) => {
  const response = await requestAnonimo.get('/gateways/biometria/consultar-publico/', { params: { cpf, detalhado } })
  return response.data
}

export const getBiometriaConfigApi = async () => {
  const response = await requestAdmin.get('/gateways/biometria/config/')
  return response.data
}

export const saveBiometriaConfigApi = async (payload) => {
  const response = await requestAdmin.post('/gateways/biometria/config/update/', payload)
  return response.data
}
